export const selectorQueryKeys = {
    pageAll: (agentId: number) => ["page-selector", "agent", agentId]
} as const;
